import React from "react";

/**
 * Fictive official seal for the VITAE-PUBLICA Tribunal.
 * Circular emblem — balance scale + hourglass — stamped style.
 */
export default function JudgmentSeal({ size = 110 }) {
  const r = size / 2;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      aria-hidden="true"
      data-testid="judgment-seal"
      className="select-none"
    >
      <defs>
        <radialGradient id="seal-bg" cx="50%" cy="45%" r="60%">
          <stop offset="0%" stopColor="#FBF6E6" />
          <stop offset="100%" stopColor="#E3D49A" />
        </radialGradient>
      </defs>
      <circle cx="60" cy="60" r="58" fill="url(#seal-bg)" stroke="#1A3C5E" strokeWidth="2" />
      <circle cx="60" cy="60" r="52" fill="none" stroke="#1A3C5E" strokeWidth="0.75" strokeDasharray="2 2" />
      {/* Outer ring text */}
      <path id="seal-top" d="M 60,12 m -44,0 a 44,44 0 1,1 88,0" fill="none" />
      <text fontSize="8" fontFamily="Merriweather, serif" fill="#1A3C5E" letterSpacing="2">
        <textPath href="#seal-top" startOffset="50%" textAnchor="middle">
          TRIBUNAL FICTIF VITALISTE
        </textPath>
      </text>
      <path id="seal-bottom" d="M 16,60 a 44,44 0 0,0 88,0" fill="none" />
      <text fontSize="7" fontFamily="Merriweather, serif" fill="#1A3C5E" letterSpacing="2">
        <textPath href="#seal-bottom" startOffset="50%" textAnchor="middle">
          DES FINANCES PUBLIQUES
        </textPath>
      </text>
      {/* Balance + hourglass emblem */}
      <g transform="translate(60,62)" stroke="#1A3C5E" strokeWidth="1.5" strokeLinecap="round" fill="none">
        {/* Vertical axis */}
        <line x1="0" y1="-20" x2="0" y2="18" />
        {/* Beam */}
        <line x1="-18" y1="-14" x2="18" y2="-14" />
        {/* Plates */}
        <path d="M -22 -10 A 4 2 0 0 0 -14 -10 L -18 -4 Z" fill="#C9A84C" stroke="#1A3C5E" />
        <path d="M 14 -10 A 4 2 0 0 0 22 -10 L 18 -4 Z" fill="#C9A84C" stroke="#1A3C5E" />
        {/* Hourglass below */}
        <path d="M -6 4 L 6 4 L -6 18 L 6 18 Z" fill="#C0392B" fillOpacity="0.5" stroke="#1A3C5E" />
        <line x1="-7" y1="4" x2="7" y2="4" />
        <line x1="-7" y1="18" x2="7" y2="18" />
      </g>
      {/* Star accent */}
      <text
        x="60"
        y="105"
        fontSize="6"
        textAnchor="middle"
        fill="#1A3C5E"
        fontFamily="Merriweather, serif"
        letterSpacing="2"
      >
        ★ VITAE-PUBLICA™ ★
      </text>
    </svg>
  );
}
